const COVI_TEST_SET_PROMPT_PREFIX = "covi_test_set_prompt:"

function createSeedId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

/** Stores a one-time prompt without exposing attached file contents in the URL. */
export function storeCoviTestSetPrompt(prompt: string): string {
  const seedId = createSeedId()
  sessionStorage.setItem(`${COVI_TEST_SET_PROMPT_PREFIX}${seedId}`, prompt)
  return seedId
}

/** Reads and deletes a prompt so refresh/back cannot submit it twice. */
export function consumeCoviTestSetPrompt(seedId: string): string | null {
  const key = `${COVI_TEST_SET_PROMPT_PREFIX}${seedId}`
  const prompt = sessionStorage.getItem(key)
  sessionStorage.removeItem(key)
  return prompt
}
